import { ButtonProps as AntdButtonProps } from 'antd';
import { Override } from 'types';

export enum ButtonType {
	Primary = "primary",
	Default = "default",
	Dashed = "dashed",
	Link = "link"
};

export enum ButtonSize {
	Small = "small",
	Middle = "middle",
	Large = "large",
};

export enum ButtonWidth {
	Full = "Full"
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ButtonProps
	extends Override<
		AntdButtonProps,
		{
			type?: ButtonType
			size?: ButtonSize
			width?: ButtonWidth
		}
	> { };

export type DefaultButtonProps = {
	onClick: NonNullable<(ButtonProps['onClick'])>;
	type: NonNullable<(ButtonProps['type'])>;
	size: NonNullable<(ButtonProps['size'])>;
	children: NonNullable<(ButtonProps['children'])>;
};

export const defaultProps: DefaultButtonProps = {
	onClick: () => { },
	type: ButtonType.Default,
	size: ButtonSize.Middle,
	children: ""
};
